import Swiper from 'swiper';
import { Navigation, HashNavigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {Modal, Tabs} from 'flowbite';

import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {scrollToggleFixed} from "../../utils/scrollFixedNav";

document.addEventListener('DOMContentLoaded', function ()
{
    scrollToggleFixed({
        navSelector: '#navbar',
        targetSelector: '#hero',
    });

    Fancybox.bind("[data-fancybox]", {});

    const swiperGalleryInteriorEl = document.querySelector('#gallery-interior');
    const swiperGalleryInteriorGridEl = document.querySelector('#gallery-grid-interior');

    if (swiperGalleryInteriorEl)
    {
        const swiperGalleryInterior = new Swiper('.swiper-gallery-interior', {
            loop: true,
            slidesPerView: 2,
            speed: 1000,
            navigation: {
                prevEl: '.swiper-button-prev-gallery-interior',
                nextEl: '.swiper-button-next-gallery-interior',
            },
            modules: [Navigation],
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                1280: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1920: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
            },
        });

    } else
    {
        console.warn('Elemento no encontrado')
    }

    if (swiperGalleryInteriorGridEl)
    {
        const swiperGalleryInterior = new Swiper('.swiper-gallery-interior', {
            loop: true,
            slidesPerView: 2,
            speed: 1000,
            navigation: {
                prevEl: '.swiper-button-prev-gallery-interior',
                nextEl: '.swiper-button-next-gallery-interior',
            },
            modules: [Navigation],
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                1280: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    watchSlidesProgress: false,
                    allowSlideNext: false,
                    allowSlidePrev: false,
                },
                1440: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    watchSlidesProgress: false,
                    allowSlideNext: false,
                    allowSlidePrev: false,
                },
                1920: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    watchSlidesProgress: false,
                    allowSlideNext: false,
                    allowSlidePrev: false,
                },
            },
        });


    } else
    {
        console.warn('Elemento no encontrado')
    }

    const swiperGallery = new Swiper('.swiper-gallery', {
        loop: true,
        slidesPerView: 2,
        // autoplay: true,
        speed: 1000,
        navigation: {
            prevEl: '.swiper-button-prev-gallery',
            nextEl: '.swiper-button-next-gallery',
        },
        modules: [Navigation],
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            1280: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1920: {
                slidesPerView: 2,
                spaceBetween: 25,
            },
        },
    });

    const swiperGalleryMain = new Swiper('.swiper-gallery-main', {
        slidesPerView: 1,
        speed: 1000,
        navigation: {
            prevEl: '.swiper-button-prev-gallery-main',
            nextEl: '.swiper-button-next-gallery-main',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
        },
    });

    const swiperModels = new Swiper('.swiper-models', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 15,
        speed: 1000,
        modules: [Navigation],
        hashNavigation: {
            watchState: true,
        },
        navigation: {
            prevEl: '.swiper-button-prev-model',
            nextEl: '.swiper-button-next-model',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1920: {
                slidesPerView: 4,
                spaceBetween: 25,
            },
        },
        on: {
            slideChange: function (swiperInstance) {
                const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                const currentHash = activeSlide.dataset.hash;

                document.querySelectorAll('.btn-floor').forEach(btn => {
                    btn.classList.remove('btn-floor-active');
                    if (btn.dataset.hash === currentHash) {
                        btn.classList.add('btn-floor-active');
                    }
                });
            }
        }

    });

    const tabsElementExtension = document.getElementById('tabs-extension');

    if (tabsElementExtension) {
        const tabButtonsExtension = tabsElementExtension.querySelectorAll('[data-tab-id]');

        const tabElementsExtension = Array.from(tabButtonsExtension).map((btn) => {
            const tabId = btn.dataset.tabId;
            return {
                id: tabId,
                triggerEl: btn,
                targetEl: document.getElementById(tabId),
            };
        });

        const optionsExtension = {
            defaultTabId: tabElementsExtension[0]?.id || null,
            activeClasses:
                `btn-gallery-active`,
            inactiveClasses:
                'btn-gallery-not-active',
        };

        const instanceOptionsExtension = {
            id: 'tabs-extension',
            override: true,
        };

        const tabsExtension = new Tabs(tabsElementExtension, tabElementsExtension, optionsExtension, instanceOptionsExtension);    } else {
    }

    const tabsElementModels = document.getElementById('tabs-models');

    if (tabsElementModels)
    {
        const tabButtonsModels = tabsElementModels.querySelectorAll('[data-tab-id]');

        const tabElementsModels = Array.from(tabButtonsModels).map((btn) => {
            const tabId = btn.dataset.tabId;
            return {
                id: tabId,
                triggerEl: btn,
                targetEl: document.getElementById(tabId),
            };
        });

        const optionsModels = {
            defaultTabId: tabElementsModels[0]?.id || null,
            activeClasses: `btn-model-active`,
            inactiveClasses: 'btn-model-not-active',
            onShow: (tabsInstance) => {
                tabButtonsModels.forEach(btn => updateButtonText(btn, false));

                if (tabsInstance._activeTab?.triggerEl) {
                    updateButtonText(tabsInstance._activeTab.triggerEl, true);
                }

                // 🟢 Solo cuando el tab se muestra, inicializa SwiperFloor
                setTimeout(() => {
                    initSwiperFloors(); // ahora sí hay slides en el DOM
                }, 100);
            }
        };


        const instanceOptionsModels = {
            id: 'tabs-models',
            override: true,
        };

        const tabsModels = new Tabs(tabsElementModels, tabElementsModels, optionsModels, instanceOptionsModels);

        document.querySelectorAll('.btn-model').forEach(button => {
            button.addEventListener('click', function() {
                const tabContentId = this.getAttribute('data-tab-id');
                const targetContent = document.getElementById(tabContentId);

                if (targetContent) {
                    // Pequeño delay para que el tab se active primero
                    setTimeout(() => {
                        targetContent.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                    }, 100);
                }
            });
        });
    }

    function updateButtonText(button, isActive) {
        if (isActive) {
            if (!button.dataset.originalText) {
                button.dataset.originalText = button.textContent.trim();
            }
            button.textContent = 'Opción seleccionada';
        } else {
            // Restaurar el texto original
            button.textContent = button.dataset.originalText || 'Quiero este modelo';
        }
    }

    const swiperFloorConfig = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 15,
        speed: 1000,
        modules: [HashNavigation],
        hashNavigation: {
            watchState: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            1280: {
                spaceBetween: 20,
            },
            1920: {
                spaceBetween: 0,
            },
        },
        on: {
            init(swiper) {
                console.log('Slides:', swiper.slides);
                console.log('Active Index:', swiper.activeIndex);
                console.log('Real Index:', swiper.realIndex);

                setTimeout(() => {
                    swiper.slideToLoop(0, 0);
                    createSlideChangeHandler(swiper.el)(swiper);
                }, 100);
            }
        }
    };

    function createSlideChangeHandler(swiperElement) {
        return function(swiperInstance) {
            // Validar que el swiper tenga slides y un índice válido
            if (!swiperInstance.slides || !swiperInstance.slides.length) {
                console.warn('Swiper no tiene slides disponibles');
                return;
            }

            const activeIndex = swiperInstance.activeIndex;
            if (activeIndex === undefined || activeIndex < 0 || activeIndex >= swiperInstance.slides.length) {
                console.warn('Índice activo del swiper no es válido:', activeIndex);
                return;
            }

            const activeSlide = swiperInstance.slides[activeIndex];
            if (!activeSlide || !activeSlide.dataset) {
                console.warn('Slide activo no tiene dataset');
                return;
            }

            const currentHash = activeSlide.dataset.hash;
            if (!currentHash) {
                console.warn('Slide activo no tiene hash');
                return;
            }

            // Encontrar los botones relacionados a este swiper específico
            let buttonSelector;

            if (swiperElement.id) {
                // Si tiene ID (caso múltiples modelos), buscar en el mismo tab-content
                const tabContent = swiperElement.closest('[role="tabpanel"]');
                if (tabContent && tabContent.id) {
                    buttonSelector = `#${tabContent.id} .btn-floor`;
                } else {
                    buttonSelector = '.btn-floor';
                }
            } else {
                // Caso simple (un modelo), usar selector general
                buttonSelector = '.btn-floor';
            }

            document.querySelectorAll(buttonSelector).forEach(btn => {
                btn.classList.remove('btn-floor-active');
                if (btn.dataset.hash === currentHash) {
                    btn.classList.add('btn-floor-active');
                }
            });
        };
    }

    function initSwiperFloors() {
        const swiperInstances = [];
        const swiperElements = document.querySelectorAll('.swiper-floor');

        swiperElements.forEach(swiperElement => {
            // Verificar que el swiper tiene slides
            const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
            const slides = swiperWrapper ? swiperWrapper.querySelectorAll('.swiper-slide') : [];

            if (slides.length === 0) {
                console.warn('Swiper no tiene slides, saltando inicialización:', swiperElement);
                return;
            }

            // Crear configuración específica para este swiper
            const config = {
                ...swiperFloorConfig,
                on: {
                    slideChange: createSlideChangeHandler(swiperElement),
                    init: function(swiperInstance) {
                        // Ejecutar el handler inicial para activar el primer botón
                        setTimeout(() => {
                            createSlideChangeHandler(swiperElement)(swiperInstance);
                        }, 100);
                    }
                }
            };

            // Inicializar el swiper
            try {
                const swiperInstance = new Swiper(swiperElement, config);
                swiperInstances.push(swiperInstance);
            } catch (error) {
                console.error('Error al inicializar swiper:', error, swiperElement);
            }
        });

        return swiperInstances;
    }

    const swiperFloors = initSwiperFloors();

    const btnOpenPresencial = document.querySelector('.btn-presencial-show');
    const modalGetnetPresencialEl = document.getElementById('modal-getnet-presencial');

    if (btnOpenPresencial && modalGetnetPresencialEl) {
        const modalGetnetPresencial = new Modal(modalGetnetPresencialEl);

        btnOpenPresencial.addEventListener('click', function(e) {
            e.preventDefault();
            modalGetnetPresencial.show();
        });
    }

});


